export default __webpack_public_path__ + "static/media/check.c48af13c.svg";